import styled from 'styled-components';

import { CustomThemeToken } from '@/theme';

interface HeaderContainerProps {
  theme: { token: CustomThemeToken };
}

export const HeaderContainer = styled.div<HeaderContainerProps>`
  .top-padding {
    padding: ${({ theme: { token } }) => token.paddingXS}px ${({ theme: { token } }) => token.padding}px;
  }

  .top-row {
    position: relative;
    display: flex;
    align-items: center;
    gap: ${({ theme: { token } }) => token.marginXS}px;
    align-self: stretch;
    min-height: ${({ theme: { token } }) => token.marginXL * 2}px;

    
    .asset-type-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: ${({ theme: { token } }) => token.marginXXS}px;

      .asset-type-icon {
        width: auto;
      }

      .asset-type-label {
        font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
        color: ${({ theme: { token } }) => token.colorTextSecondary};
      }
    }

    .asset-title {
      display: flex;
      flex-direction: column;
      overflow: hidden;
      flex-grow: 1;
      gap: ${({ theme: { token } }) => token.marginXXS}px;

      .name {
        font-size: ${({ theme: { token } }) => token.fontSize}px;
        color: ${({ theme: { token } }) => token.colorText};
        font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
      }

      .model {
        font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
        color: ${({ theme: { token } }) => token.colorTextSecondary};
      }
    }

    .connectivity-icon-wrapper {
      width: auto;
      min-width: 92px;
      height: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;
      gap: ${({ theme: { token } }) => token.marginXS}px;
      padding: ${({ theme: { token } }) => token.paddingXXS}px;

      .icons-row {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;

        > svg {
          width: 20px;
          height: 20px;
          flex-shrink: 0;
        }

        > div {
          width: 24px;
          height: 24px;
          flex-shrink: 0;

          svg {
            width: 24px;
            height: 24px;
          }
        }
      }

      .status-icon {
        display: flex;
        justify-content: center;
      }

      .status-name {
        font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
        color: ${({ theme: { token } }) => token.colorTextSecondary};
      }
    }
  }

  .horizontal-border {
    height: 1px;
    width: 100%;
    background-color: ${({ theme: { token } }) => token.colorBorderSecondary};
  }
`;

